import Layout from "../components/Layout/Layout";
import DealerStockContent from "../components/DealerStockContent/DealerStockContent";

const DealerStock = () => {
    return (
        <Layout>
            <DealerStockContent />
        </Layout>
    );
};

export default DealerStock;
